/**
 * API Konfigürasyon Dosyası
 * Tüm API ayarları bu dosyadan yönetilir
 * Environment variable'lar üzerinden değiştirilebilir
 */

const apiConfig = {
  // Base URL - Environment variable'dan veya default değer
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://api.articles.com',
  
  // API Version (v1 veya v2)
  apiVersion: process.env.REACT_APP_API_VERSION || 'v1',
  
  // Host Name
  hostName: process.env.REACT_APP_HOST_NAME || 'www.habertoplayici.com.tr',
  
  // Request Timeout (milisaniye)
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000,
  
  // Retry Configuration
  retry: {
    count: parseInt(process.env.REACT_APP_API_RETRY_COUNT) || 3,
    delay: parseInt(process.env.REACT_APP_API_RETRY_DELAY) || 1000
  },
  
  // Headers
  headers: {
    'Content-Type': 'application/json'
  },
  
  // Select Fields (API'den çekilecek alanlar)
  selectFields: ['Title', 'ImageUrl', 'Date', 'Url']
};

// API Endpoint - version'a göre dinamik
apiConfig.endpoint = `/${apiConfig.apiVersion}/api/GenericObjectItemList`;

// Full API URL'i oluştur
apiConfig.fullURL = `${apiConfig.baseURL}${apiConfig.endpoint}`;

/**
 * v1 filter formatını v2 formatına dönüştürür
 * v1: { League: { Filter: 'Equal', Value: 'super-lig' } }
 * v2: [{ fieldName: 'League', operation: 'Equal', fieldValue: 'super-lig' }]
 */
const transformFiltersToV2 = (v1Filters) => {
  if (!v1Filters) return [];
  
  return Object.entries(v1Filters).map(([fieldName, filterDef]) => ({
    fieldName,
    operation: filterDef.Filter,
    fieldValue: filterDef.Value
  }));
};

/**
 * v2 filter formatını v1 formatına dönüştürür
 * v2: [{ fieldName: 'League', operation: 'Equal', fieldValue: 'super-lig' }]
 * v1: { League: { Filter: 'Equal', Value: 'super-lig' } }
 */
const transformFiltersToV1 = (v2Filters) => {
  if (!v2Filters || !Array.isArray(v2Filters)) return undefined;
  
  return v2Filters.reduce((acc, filter) => {
    acc[filter.fieldName] = {
      Filter: filter.operation,
      Value: filter.fieldValue
    };
    return acc;
  }, {});
};

/**
 * Request body'sini API versiyonuna göre formatlar
 * Her iki versiyon için de uyumlu request body döner
 */
apiConfig.formatRequestBody = (params) => {
  const { hostName, url, selectFields, page, sortBy, sortAscending, filters, pageSize } = params;
  
  const baseBody = {
    hostName: hostName || apiConfig.hostName,
    url,
    selectFields: selectFields || apiConfig.selectFields,
    page: page || 1,
    sortBy: sortBy || 'Date',
    sortAscending: sortAscending ?? false
  };
  
  if (pageSize) {
    baseBody.pageSize = pageSize;
  }
  
  // Versiyon bazlı filter formatlaması
  if (filters) {
    if (apiConfig.apiVersion === 'v2') {
      // v2 için array formatında filters
      if (Array.isArray(filters)) {
        baseBody.filters = filters;
      } else {
        // v1 formatından v2'ye dönüştür
        baseBody.filters = transformFiltersToV2(filters);
      }
    } else {
      // v1 için object formatında filters
      if (Array.isArray(filters)) {
        // v2 formatından v1'e dönüştür
        baseBody.filters = transformFiltersToV1(filters);
      } else {
        baseBody.filters = filters;
      }
    }
  }
  
  return baseBody;
};

/**
 * API versiyonunu kontrol eder
 */
apiConfig.isV2 = () => apiConfig.apiVersion === 'v2';

// Config validation
const validateConfig = () => {
  if (!apiConfig.baseURL) {
    console.error('❌ API Base URL is not configured!');
    return false;
  }
  if (!apiConfig.hostName) {
    console.error('❌ Host Name is not configured!');
    return false;
  }
  return true;
};

// Sadece hata durumunda logla
validateConfig();

export default apiConfig;
